<div class="container-fluid">
  <div class="row">
    <div class="col-6">
      @if (!bed) {
        <h2 mat-dialog-title>Add Bed</h2>
      }
    </div>
    <div class="col-6 text-right">
      @if (!bed) {
        <button mat-icon-button [mat-dialog-close]="true" style="margin-left:auto">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-dialog-content [formGroup]="form1">
        <div class="row">
          <div class="col-lg-12">
            @if (formAlert) {
              <div class="block">
                <div style="flex: 0 0 calc(100% - 10px); text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>
          <div class="col-6">
            <mat-form-field class="block">
              <mat-label>Type</mat-label>
              <mat-select [(value)]="form1.value.bedType" formControlName="bedType">
                @for (stat of bedTypes; track stat) {
                  <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.bedType; track validation) {
                <mat-error>
                  @if (form1.get('bedType').hasError(validation.type) && (form1.get('bedType').dirty || form1.get('bedType').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="block">
              <mat-label>Sleeps Max</mat-label>
              <input matInput formControlName="sleepsMax" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.sleepsMax; track validation) {
                <mat-error>
                  @if (form1.get('sleepsMax').hasError(validation.type) && (form1.get('sleepsMax').dirty || form1.get('sleepsMax').touched)) {
                    <mat-error class="error-message">
                      {{validation.message}}
                    </mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-lg-12">
            <mat-form-field class="block">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="500"
              matTooltip="Enter description, paragrphs are ok."></textarea>
              @for (validation of validationMessages.description; track validation) {
                <mat-error>
                  @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                    <mat-error class="error-message">
                      {{validation.message}}
                    </mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-lg-12">
            <div class="flex-1">@if (bedId) {
              <button style="float:left;" mat-raised-button color="error" (click)="formDelete()" [disabled]="!form1.valid">Delete Bed</button>
            }</div>
            <div class="flex-1">@if (bedId) {
              <button style="float:right;" mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update Bed</button>
            }</div>
          </div>
          <div class="col-lg-12">
            <div class="flex-1">@if (!bedId) {
              <button style="float:left;" mat-raised-button [mat-dialog-close]="true">Done</button>
            }</div>
            <div class="flex-1">@if (!bedId) {
              <button style="float:right;" mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Add Bed</button>
            }</div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </div>
</div>